module.exports = __webpack_public_path__ + "img/Condominio_das_Americas_AereaEntrada.200521f1.jpg";